import { render, staticRenderFns } from "./TemplateManageDialog.vue?vue&type=template&id=1b1182c8&scoped=true"
import script from "./TemplateManageDialog.vue?vue&type=script&lang=js"
export * from "./TemplateManageDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplateManageDialog.vue?vue&type=style&index=0&id=1b1182c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1182c8",
  null
  
)

export default component.exports